module.exports = __webpack_public_path__ + "static/media/3.f6939a57.svg";